export default "__VITE_ASSET__gZcNh6TI__"